import React, { useEffect, useState } from "react";
import userAuth from '../../Config/userauth';
import { Header } from "../../Components";
import { useLocation } from 'react-router-dom';
import { Login } from "./login";
import { Cartera } from "./cartera";
import { Registracion } from "./registracion";
import { Canales } from "./canales";
import { Liquidacion } from "./liquidacion";
import { Rechazo } from "./rechazo";
import { EnvioFacturas } from "./envio-facturas";
import { Certificados } from "./certificado-retencion";
import { GestionTramites } from "./gestionTramites";
import { Deudores } from "./deudores";

const useQuery = () => new URLSearchParams(useLocation().search);

export function Tutoriales() {
    const [activeSection, setActiveSection] = useState('registration');
    const query = useQuery();
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
        const seccion = query.get('seccion');
        if (seccion) setActiveSection(seccion);
    }, []);

    const handleNext = () => setActiveStep(prev => prev + 1);
    const handleBack = () => setActiveStep(prev => prev - 1);
    const handleReset = () => setActiveStep(0);

    const renderComponent = () => {
        const props = { activeStep, setSteps };
        switch (activeSection) {
            case 'como-registrarse': return <Registracion {...props} />;
            case 'como-ingresar': return <Login {...props} />;
            case 'cartera': return <Cartera {...props} />;
            case 'canales': return <Canales {...props} />;
            case 'liquidacion': return <Liquidacion {...props} />;
            case 'rechazo': return <Rechazo {...props} />;
            case 'envio-facturas': return <EnvioFacturas {...props} />;
            case 'certificado-retencion': return <Certificados {...props} />;
            case 'gestion-tramites': return <GestionTramites {...props} />;
            case 'deudores': return <Deudores {...props} />;
            default: return <div>404 Not Found</div>;
        }
    };

    return (
        <>
            {!userAuth.isAuthenticated() && <Header />}

            <div className="container-fluid" style={{ height: '92vh' }}>
                <div className="row h-100">
                    {/* Sidebar */}
                    <div className="col-md-3 bg-info text-white p-3">
                        <h6>Tutoriales</h6>
                        <hr />
                        <ul className="list-group list-group-flush">
                            {[
                                ['como-registrarse', 'Registración'],
                                ['como-ingresar', 'Ingresar'],
                                ['cartera', 'Cartera'],
                                ['liquidacion', 'Liquidación'],
                                ['canales', 'Canales'],
                                ['rechazo', 'Rechazo'],
                                ['envio-facturas', 'Envío de facturas'],
                                ['certificado-retencion', 'Certificados de retención'],
                                ['gestion-tramites', 'Gestión de trámites'],
                                ['deudores', 'Deudores por premio']
                            ].map(([key, label]) => (
                                <li key={key} className="list-group-item list-group-item-action bg-info text-white border-0 p-2"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setActiveSection(key)}>
                                    <i className="bi bi-tag me-2"></i>{label}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contenido */}
                    <div className="col-md-9 bg-light p-4">
                        <div>{renderComponent()}</div>

                        <div className="mt-4">
                            {activeStep === steps.length ? (
                                <button className="btn btn-secondary" onClick={handleReset}>Reiniciar</button>
                            ) : (
                                <div className="d-flex justify-content-between">
                                    <button className="btn btn-outline-secondary"
                                            onClick={handleBack}
                                            disabled={activeStep === 0}>
                                        Volver
                                    </button>
                                    <button className="btn btn-primary" onClick={handleNext}>
                                        {activeStep === steps.length - 1 ? 'Terminar' : 'Siguiente'}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
